import {
  Box,
  Button,
  Flex,
  HStack,
  InputGroup,
  Input,
  InputLeftElement,
  MenuItem,
  MenuList,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { openCreateVideos } from "../../../modules/admin-modules/models/Actions";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";

const SearchBar = ({ setAdd, setSelectedData, searchTerm, setSearchTerm, filteredCount }) => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.videoRequests.count);

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  return (
    <VStack w="100%" my={{ base: "50px", md: "30px" }}>
      <Flex
        alignItems="center"
        w="100%"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Text
          fontSize="24px"
          fontWeight="600"
          color="main_1"
          width={{ base: "100%", md: "20%" }}
          mb={{ base: "10px", md: 0 }}
        >
          طلبات المشاهدة
        </Text>

        <Flex alignItems="center" flexWrap="wrap" gap={2}>
          <Box display={{ base: "none", md: "block" }}>
            <LogoutMenu />
          </Box>
        </Flex>
      </Flex>
      <Flex w="100%" alignItems="center" gap={4} flexWrap="wrap">
        <InputGroup w={{ base: "100%", md: "300px" }}>
          <InputLeftElement pointerEvents="none">
            <RiSearch2Fill color="gray.300" />
          </InputLeftElement>
          <Input
            placeholder="ابحث عن فيديو أو طالب..."
            value={searchTerm || ""}
            onChange={(e) => setSearchTerm(e.target.value)}
            borderRadius="16px"
          />
        </InputGroup>
        <Text w={{ base: "100%", md: "auto" }} fontSize="20px" textAlign="right">
          عدد الطلبات: {searchTerm ? filteredCount : count}
        </Text>
      </Flex>
    </VStack>
  );
};

export default SearchBar;
